import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { ErrorMessage, Title, Subtitle, ButtonWrapper, PrimaryButton } from '../styles';

interface InvalidTokenViewProps {
  onBackToLogin: () => void;
}

const InvalidTokenView: React.FC<InvalidTokenViewProps> = ({ onBackToLogin }) => {
  return (
    <>
      <ErrorMessage>
        <Title style={{ color: 'inherit', marginBottom: '8px' }}>Invalid Reset Link</Title>
        <Subtitle style={{ color: 'inherit', marginBottom: '0' }}>
          This password reset link is invalid or has expired.
        </Subtitle>
        <Subtitle style={{ color: 'inherit', marginTop: '8px', fontSize: '12px' }}>
          Please request a new password reset link.
        </Subtitle>
      </ErrorMessage>
      
      <ButtonWrapper>
        <PrimaryButton
          icon={<FontAwesomeIcon icon={faArrowLeft} />}
          type="primary"
          onClick={onBackToLogin}
          block
        >
          Back to Login
        </PrimaryButton>
      </ButtonWrapper>
    </>
  );
};

export default InvalidTokenView;
